@if (title()) {
  <h2 class="page-title">{{ title() }}</h2>
}

@if (totalRecords() > 0) {
  <div class="grid">
    @for (color of colorsPage(); track color) {
      <div [ngClass]="componentStyleClass()">
        <ppg-color-chip
          class="flex md:inline w-full"
          [styleClass]="'flex md:inline justify-content-center w-full'"
          [color]="color"
          (favoriteButtonClicked)="onFavoriteButtonClicked($event)"
          (colorDetailsLinkClicked)="onColorDetailsLinkClicked($event)" />
      </div>
    }
  </div>

  @if (totalRecords() > rows()) {
    <ppg-horizontal-divider />
    <div class="flex flex-column align-items-center xl:align-items-end">
      <p-paginator
        [rows]="numberOfItemsDisplayedPerPage()"
        [first]="firstRow()"
        [rowsPerPageOptions]="paginatorConfig.rowsPerPageOptions"
        [totalRecords]="totalRecords()"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="resources.currentPageReportTemplateResourceKey | resourceValue"
        ppgScrollOnPageChange
        (onPageChange)="onPageUpdate($event)"
        [pageLinkSize]="pageLinkSize()" />
    </div>
  }
} @else if (emptyMessageTemplate) {
  <ng-content />
  <ng-container *ngTemplateOutlet="emptyMessageTemplate"></ng-container>
}
